import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { VStack, Link as ChakraLink } from '@chakra-ui/react';

export default function Downloads() {
  const { meta } = useStaticQuery(DOWNLOADS_QUERY);
  const { downloads } = meta;

  return (
    <VStack spacing='8px' alignItems='flex-start'>
      {downloads.map((link) => (
        <ChakraLink
          href={`${link.file.asset.url}/${link.file.asset.originalFilename}`}
          target='_blank'
          rel='noopener noreferrer'
          key={link._key}
          _hover={{
            background: 'transparent',
            color: 'navy',
            textDecoration: 'none',
          }}
        >
          {link.text}
        </ChakraLink>
      ))}
    </VStack>
  );
}

const DOWNLOADS_QUERY = graphql`
  query Downloads {
    meta: sanityMeta {
      downloads {
        _key
        text
        file {
          asset {
            originalFilename
            url
          }
        }
      }
    }
  }
`;
